import Hero from "../utils/hero";


const Home = () => {

  return (
    <Hero 
      title="AI at the Heart of Every Campus"
      subtitle="Helping students - one at a time - with crucial information for educated choices"
      />
  );
};


export default Home;
